import { State } from '../states';

// Selectors

export const getPeriod = (state: State) => state.controls.period;



// WEBPACK FOOTER //
// ./src/store/selectors/controls.selector.ts